import { routes } from '../modules/core';

export default routes;
